import { StyleRules } from '@mui/styles';

const styles = (): StyleRules => ({
    headerLabel: {
        margin: '5px 0px 5px 0px',
        padding: '0px',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: 1.5,
        letterSpacing: '0.2px',
    },
});

export default styles;
